import { UseQueryOptions, useQuery } from 'react-query'

import {
  getArticles,
  getCategories,
  getTags,
  getArticleBySlug
} from 'app/services/Api/blog'
import Deserializer from 'app/services/Deserializer'

import { blogKeys } from './blog.keys'

export const blogConfig = {
  getArticles: {
    key: blogKeys.getArticles,
    request: async ({ queryKey }) => {
      const [_key, _, params] = queryKey
      const resp = await getArticles(params)

      const articles = await Deserializer.deepDeserialize(resp.articles)

      return {
        articles,
        articles_count: resp.articles_count,
        pagy: resp.pagy
      }
    }
  },
  getCategories: {
    key: blogKeys.getCategories(),
    request: getCategories
  },
  getTags: {
    key: blogKeys.getTags(),
    request: getTags
  },
  getArticleBySlug: {
    key: blogKeys.getArticleBySlug,
    request: async ({ queryKey }) => {
      const [_key, _, slug] = queryKey

      const articles = await getArticleBySlug(slug)

      return articles
    }
  }
}

interface UseGetBlogArticles {
  params: BlogQueryParams
  options?: UseQueryOptions<BlogPaginationArticlesModel>
}

export const useGetBlogArticles = (props: UseGetBlogArticles) => {
  const { params, options } = props
  const { getArticles: config } = blogConfig

  const state = useQuery<BlogPaginationArticlesModel>(
    config.key(params),
    config.request,
    options
  )

  return state
}

interface UseGetBlogArticleCategories {
  options?: UseQueryOptions<BlogCategoryModel[]>
}

export const useGetBlogArticleCategories = (
  props?: UseGetBlogArticleCategories
) => {
  const { options } = props || {}
  const { getCategories: config } = blogConfig

  const state = useQuery<BlogCategoryModel[]>(
    config.key,
    config.request,
    options
  )

  return state
}

interface UseBlogArticleTags {
  options?: UseQueryOptions<BlogTagModel[]>
}

export const useGetBlogArticleTags = (props?: UseBlogArticleTags) => {
  const { options } = props || {}
  const { getTags: config } = blogConfig

  const state = useQuery<BlogTagModel[]>(config.key, config.request, options)

  return state
}

interface UseGetBlogArticleBySlug {
  slug: string
  options?: UseQueryOptions<BlogArticleDetailModel>
}

export const useGetBlogArticleBySlug = (props: UseGetBlogArticleBySlug) => {
  const { slug, options } = props
  const { getArticleBySlug: config } = blogConfig

  const state = useQuery<BlogArticleDetailModel>(
    config.key(slug),
    config.request,
    options
  )

  return state
}
